import React, { Suspense, useEffect, useState } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import IconStopPropagation from "../Grid/Grid/IconStopPropagation.js";

import "./FilesActionGroup.scss";
import { useMail } from "contexts/mailContext/mailContext.js";

const ALERTED_SPAM_STATUS = "alerted_spam";
const SHARE_COMPONENT_NAME = "Share";

const ActionComponentList = ({
  actionList,
  itemId,
  lightBox,
  folderId,
  withTitle,
}) => {
  const [ComponentList, setComponentList] = useState([]);
  const { getSpamStatus } = useMail();

  useEffect(() => {
    actionList.map((action) => {
      if (
        getSpamStatus() === ALERTED_SPAM_STATUS &&
        action !== SHARE_COMPONENT_NAME
      ) {
        const ActionComponent = React.lazy(() =>
          import(`./${action}Action.js`)
        );
        setComponentList((prev) => [...prev, ActionComponent]);
      } else if (!getSpamStatus() || getSpamStatus() !== ALERTED_SPAM_STATUS) {
        const ActionComponent = React.lazy(() =>
          import(`./${action}Action.js`)
        );
        setComponentList((prev) => [...prev, ActionComponent]);
      }
    });

    return () => {
      setComponentList([]);
    };
  }, [actionList, getSpamStatus()]);

  return (
    <Suspense>
      {ComponentList.map((ActionComponent, index) => {
        return (
          <IconStopPropagation key={actionList[index] + index}>
            <ActionComponent {...{ itemId, lightBox, folderId, withTitle }} />
          </IconStopPropagation>
        );
      })}
    </Suspense>
  );
};

const FilesActionGroup = ({
  actionList,
  className,
  itemId,
  folderId,
  lightBox,
  withTitle,
}) => {
  const classes = classNames([
    "action-group",
    className,
    withTitle ? "with-action-titles" : "",
  ]);

  return (
    <div className={classes}>
      <ActionComponentList
        {...{ actionList, itemId, lightBox, folderId, withTitle }}
      />
    </div>
  );
};

FilesActionGroup.propTypes = {
  actionList: PropTypes.array.isRequired,
};

FilesActionGroup.defaultProps = {
  actionList: [],
  lightBox: false,
  itemId: null,
};

export default FilesActionGroup;
